import FormLoginContainer from "./formLoginContainer";
import HeaderLoginLaptop from "./headerLoginLaptop";
import LoginPopupContainer from "./loginPopupContainer";

export default function MainLogin() {
  return (
    <div className="">
      <HeaderLoginLaptop />
      <LoginPopupContainer /> 

    </div>
  );
}
